/**
 * @desc 更新会员企业认证
 */
import {
  AuditEnterpriseEntity,
  AuditEnterpriseForm
} from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type UpdateAuditEnterpriseParameter = AuditEnterpriseForm

const method = 'PUT'
const url = '/auth/audit/enterprise'

export const updateAuditEnterpriseApi = (
  data?: UpdateAuditEnterpriseParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<AuditEnterpriseEntity>({
    method,
    url,
    data,
    ...config
  })
}

updateAuditEnterpriseApi.method = method
updateAuditEnterpriseApi.url = url
